import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlays" }

import { computed, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n'
import { useGameState } from '@/services/composition';
import { Hotspot, useHotspots, useScreenHotspots } from '@/services/stores/hotspots'
import Delay from '@/core/Delay';

import DesktopHotspots from '@/components/DesktopHotspots/DesktopHotspots.vue';
import UIJourneyCurrentState from '@/components/UIJourneyCurrentState/UIJourneyCurrentState.vue';
import UINavbar from '@/components/UINavbar/UINavbar.vue';
import UIMiniMap from '@/components/UIMiniMap/UIMiniMap.vue';
import UIPlayerStandStatus from '@/components/UIPlayerStandStatus/UIPlayerStandStatus.vue';
import UIGameNotification from '@/components/UIGameNotification/UIGameNotification.vue';
import UIUserHint from '@/components/UIUserHint/UIUserHint.vue';

import { STAND_HEIGHT } from '@/webgl/activities/desktop/controllers/CameraController'
import Viewport from '@/store/modules/Viewport';


export const CROUCH_TIMEOUT = 2000

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { t } = useI18n()

const { hotspots } = useHotspots()
const { findHotspot } = useScreenHotspots()

const timeoutID = ref(null)
const notifyUser = ref(false)

const gameGuideProps = computed(() => {
  return {
    icon: 'move-away',
    title: t(`hotspots.${state.value.matches('tuto.xr.exit_room') ? 'start_escape' : 'exit_room'}.label`),
    description: t(`hotspots.${state.value.matches('tuto.xr.exit_room') ? 'start_escape' : 'exit_room'}.description`),
  }
})

const showHotspots = computed(() => {
  return true//!state.value.matches('tuto.xr.move_around') && !state.value.matches('tuto.xr.crouch')
})

const visibleHotspots = computed(() => {
  return hotspots.filter(hotspot => {
    const screenHotspot = findHotspot(hotspot.id)
    return hotspot.states.some(hState => state.value.matches(hState)) && screenHotspot.isVisible
  }) as Hotspot[]
})

const showGameGuide = computed(() => {
  return state.value.matches('tuto.xr.exit_room')
  // return state.value.matches('tuto.xr.exit_room') || state.value.matches('game.bedroom.exit_room') || state.value.matches('game.corridor.exit_room')  || state.value.matches('game.studyroom.exit_room')  || state.value.matches('game.living.exit_room') 
})

const showTutoXRExitRoomHint = computed(() => {
  return state.value.matches('tuto.xr.exit_room')
})

const tutoXRExitRoomHintText = computed(() => {
  if(Viewport.isMobile) {
    return t('tuto.desktop.move_around.guide_mobile')
  } else {
    return t('tuto.desktop.move_around.guide')
  }
})

const inFog = computed(() => {
  const fogHeight = state.value.context.fogPreset.ceilingHeight
  if (!state.value.context.fogPreset.ceilingHeight) return

  return fogHeight < STAND_HEIGHT
})

const isCrouched = computed(() => {
  return state.value.context.isCrouched
})

const isStateGameCorridor = computed(() => {
  return state.value.matches('game.corridor')
})

const showCrouchHint = computed(() => {
  return inFog.value && !isCrouched.value && isStateGameCorridor.value && !notifyUser.value && !showTutoXRExitRoomHint.value //&& state.value.context.hotspotHovered === -1
})

watch(isCrouched, async (isCrouched) => {
  if (!isStateGameCorridor.value) {
    notifyUser.value = false
    return
  }
  if (isCrouched) {
    notifyUser.value = true
  } else {
    await Delay(CROUCH_TIMEOUT)
    notifyUser.value = false
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UIMiniMap),
    _createVNode(UIPlayerStandStatus),
    _createVNode(DesktopHotspots),
    _createVNode(UIJourneyCurrentState),
    _createVNode(UINavbar),
    (_unref(showCrouchHint))
      ? (_openBlock(), _createBlock(UIUserHint, {
          key: 0,
          class: "crouch",
          hint: "down"
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('game.hint.crouch')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(UIGameNotification)
  ]))
}
}

})